import { get } from "../../api";

const getType = (typeId, headers, isSSRCall) =>
  get("getType", headers, `?typeId=${typeId}`, isSSRCall);

export { getType };
